<div *ngIf="checkMode === 'recalculate'">
  <div class="row" style="border-bottom: 2px solid #ccc; margin-bottom: 10px">
    <div class="col-sm-11 movable">
      <h3
        class="head"
        cdkDrag
        cdkDragHandle
        cdkDragRootElement=".cdk-overlay-pane"
      >
        RECALCULATE
      </h3>
    </div>
    <div class="col-sm-1">
      <button
        type="button"
        class="btn btn-dark btn-circle btn-xl"
        [mat-dialog-close]="true"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span aria-hidden="true">×</span>
      </button>
    </div>
  </div>

  Are you sure, you want to recalculate for this part number: {{ partNumber }}

  <div class="text-right" style="margin-right: -15px; margin-top: 10px">
    <button class="review_btn" mat-button (click)="recalculate()">
      Recalculate
    </button>
    <button class="cancel_btn" mat-button mat-dialog-close="cancel">
      Cancel
    </button>
  </div>
</div>

<!-- addComment -->
<div *ngIf="checkMode === 'addComment'">
  <div class="row" style="border-bottom: 2px solid #ccc; margin-bottom: 10px">
    <div class="col-sm-11 movable">
      <h3
        class="head"
        cdkDrag
        cdkDragHandle
        cdkDragRootElement=".cdk-overlay-pane"
      >
        ADD COMMENT
      </h3>
    </div>
    <div class="col-sm-1">
      <button
        type="button"
        class="btn btn-dark btn-circle btn-xl"
        [mat-dialog-close]="true"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span aria-hidden="true">×</span>
      </button>
    </div>
  </div>
  <form [formGroup]="addCommentform">
    <div class="row">
      <div class="col-sm-12" style="margin-top: 10px; margin-left: 5px">
        <div class="drpchildctrl">
          <textarea
            formControlName="comment"
            maxlength="250"
            placeholder="Enter"
            rows="4"
            class="comment-box"
          ></textarea>
          <p *ngIf="commentError != ''" style="color:red">{{commentError}}</p>
        </div>
      </div>
    </div>
  </form>
  <div class="text-right" style="margin-right: -15px; margin-top: 10px">
    <button class="review_btn" mat-button (click)="saveComment()" >
      Save (UVR)
    </button>
    <button class="cancel_btn" mat-button mat-dialog-close="cancel">
      Cancel
    </button>
  </div>
</div>

<!-- Showing another Modal -->
<div *ngIf="checkMode === 'addManualOrder'">
  <div class="row" style="border-bottom: 2px solid #ccc; margin-bottom: 10px">
    <div class="col-sm-11 movable">
      <h3
        class="head"
        cdkDrag
        cdkDragHandle
        cdkDragRootElement=".cdk-overlay-pane"
      >
        RAISE MANUAL ORDER
      </h3>
    </div>
    <div class="col-sm-1">
      <button
        type="button"
        class="btn btn-dark btn-circle btn-xl"
        [mat-dialog-close]="true"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span aria-hidden="true">×</span>
      </button>
    </div>
  </div>
  <form [formGroup]="addManualform">
    <div class="row">
      <div class="col-sm-6" style="margin-top: 10px">
        <div class="drpchildctrl">
          <span class="v1"></span>
          <label class="searchLable">{{ label }}</label>
          <input
            formControlName="qty"
            type="text"
            maxlength="10"
            placeholder="--Type--"
            class="key"
            [style]="{ width: '100%' }"
            (input)="onInput($event)"
          />
          <ng-container *ngIf="addManualform.get('qty').errors && submitted">
            <small *ngIf="addManualform.get('qty').errors?.required">
              # OF LOTS is required.
            </small>
          </ng-container>
        </div>
        <div class="drpchildctrl">
          <label class="searchLable">ORDER TYPE</label>
          <p-dropdown
            [filter]="true"
            [options]="toOrder"
            optionLabel="order_type"
            placeholder="Select"
            formControlName="orderType"
            [style]="{ width: '100%' }"
            [styleClass]="'custom-dropdown'"
          ></p-dropdown>
        </div>
      </div>
    </div>
  </form>
  <div class="text-right" style="margin-right: -15px; margin-top: 10px">
    <button class="review_btn" mat-button (click)="saveManualOrder()">
      Save (UVR)
    </button>
    <button class="cancel_btn" mat-button mat-dialog-close="cancel">
      Cancel
    </button>
  </div>
</div>
<!-- //Add for Tap request -->
<div *ngIf="checkMode === 'addTapRequest'">
  <div class="row" style="border-bottom: 2px solid #ccc; margin-bottom: 10px">
    <div class="col-sm-11 movable">
      <h3
        class="head"
        cdkDrag
        cdkDragHandle
        cdkDragRootElement=".cdk-overlay-pane"
      >
        RAISE TAP REQUEST
      </h3>
    </div>
    <div class="col-sm-1">
      <button
        type="button"
        class="btn btn-dark btn-circle btn-xl"
        [mat-dialog-close]="true"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span aria-hidden="true">×</span>
      </button>
    </div>
  </div>
  <form [formGroup]="addTapRequestform">
    <div class="successMessage alert-dismissible">
      <div *ngIf="warningMessage" class="alert alert-warning" role="alert">
        {{ warningMessage }}
        <button
          type="button"
          class="btn-close"
          (click)="removeMessage()"
          data-bs-dismiss="alert"
          aria-label="Close"
        ></button>
      </div>
      <div *ngIf="successMessage" class="alert alert-success" role="alert">
        {{ successMessage }}
        <button
          type="button"
          class="btn-close"
          (click)="removeMessage()"
          data-bs-dismiss="alert"
          aria-label="Close"
        ></button>
      </div>
    </div>
    <div class="row" style="margin-top: 10px">
      <div class="col-sm-6">
        <div class="drpchildctrl">
          <span class="v1"></span>
          <label class="searchLable">{{ label }}</label>
          <input
            formControlName="qty"
            type="text"
            maxlength="10"
            placeholder="--Type--"
            class="key"
            [style]="{ width: '100%' }"
            (input)="onInput($event)"
          />
          <ng-container
            *ngIf="addTapRequestform.get('qty').errors && submitted"
          >
            <small *ngIf="addTapRequestform.get('qty').errors?.required">
              # OF LOTS is required.
            </small>
          </ng-container>
        </div>
        <div class="drpchildctrl">
          <span class="v1"></span>
          <label class="searchLable">ORDER TYPE</label>
          <p-dropdown
            [filter]="true"
            [options]="toOrder"
            optionLabel="order_type"
            placeholder="Select"
            formControlName="orderType"
            [style]="{ width: '100%' }"
            [styleClass]="'custom-dropdown'"
          ></p-dropdown>
        </div>
        <div class="drpchildctrl">
          <span class="v1"></span>

          <label class="searchLable">DATE BY WHEN </label>
          <input
            formControlName="date_by_when"
            [max]="TextDateTo"
            class="form-control-sm"
            [style]="{ width: '100%' }"
            type="date"
            style="width: 100px"
          />
          <ng-container
            *ngIf="addTapRequestform.get('date_by_when').errors && submitted"
          >
            <small
              *ngIf="addTapRequestform.get('date_by_when').errors?.required"
            >
              Date by when is required.
            </small>
          </ng-container>
        </div>
      </div>
    </div>
    <ng-container *ngIf="errorMessage1">
      <p style="color: red">{{ errorMessage1 }}</p>
    </ng-container>
  </form>
  <div class="text-right" style="margin-right: -15px; margin-top: 10px">
    <button class="review_btn" mat-button (click)="saveTapRequest()">
      Save (UVR)
    </button>
    <button class="cancel_btn" mat-button mat-dialog-close="cancel">
      Cancel
    </button>
  </div>
</div>
